import {ref, onMounted, computed} from 'vue';
import {useLaunchEnv} from "./useLaunchEnv";

export function useAppInstallPopup() {
    const isVisible = ref(false);
    const platform = ref<'android' | 'ios' | 'other'>('other');
    const isInstalled = ref(false);
    const popupType = ref<'android' | 'ios' | null>(null);
    const safariWarningVisible = ref(false);
    const { isPwa, isTelegram } = useLaunchEnv();

    const detectPlatform = () => {
        const ua = navigator.userAgent.toLowerCase();
        if (/android/.test(ua)) platform.value = 'android';
        else if (/iphone|ipad|ipod/.test(ua)) platform.value = 'ios';
        else platform.value = 'other';
    };

    const isMobileDevice = () => {
        const ua = navigator.userAgent.toLowerCase();
        const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        const isPhone = /iphone|ipod|android/.test(ua) && isTouch;
        return isPhone;
    };

    const checkInstallStatus = () => {
        isInstalled.value = localStorage.getItem('app_installed') === 'true';
    };

    const markAsInstalled = () => {
        // localStorage.setItem('app_installed', 'true');
        // isInstalled.value = true;
        isVisible.value = false;
    };

    const isSafari = () => {
        const ua = navigator.userAgent.toLowerCase();
        const isIOS = /iphone|ipad|ipod/.test(ua);
        const isSafari = isIOS && !/crios|fxios|edgios|opera|opios|mercury/.test(ua);
        return isSafari;
    };


    const closePopup = () => {
        isVisible.value = false;
        safariWarningVisible.value = false;
    };

    const isTelegramLaunch = () => {
        const url = window.location.href.toLowerCase();

        return Boolean(
            isTelegram.value ||
            (window as any).launchEnv === "telegram" ||
            (window as any).Telegram?.WebApp ||
            localStorage.getItem("telegram_init_data") ||
            url.includes("tgwebappdata") ||
            url.includes("telegram-web-app") ||
            new URLSearchParams(window.location.search).get("src") === "telegramm"
        );
    };


    const isWebAppDomain = () => {
        return window.location.hostname === 'web.tinderone.app';
    };

    const maybeShowPopup = () => {

        if (!isMobileDevice() || isTelegramLaunch() || isWebAppDomain()) return;

        const src = ref<string | null>(
            new URLSearchParams(window.location.search).get("src")
        );

        const visiblePwa = computed(() => {
            return src.value === "pwa" || isPwa.value;
        });

        // Если открыто по ссылке с ?src=pwa, считаем установленным на iOS
        if (platform.value === 'ios' && visiblePwa.value) {
            markAsInstalled();
            return;
        }
        if (isInstalled.value || platform.value === 'other') return;

        // const lastShown = localStorage.getItem('app_popup_last_shown');
        // const now = Date.now();
        //
        // const shouldShow = !lastShown || now - parseInt(lastShown) > 24 * 60 * 60 * 1000;
        //
        // if (!shouldShow) return;

        if (platform.value === 'ios') {
            if (!isSafari()) {
                popupType.value = 'ios';
                safariWarningVisible.value = true;
                isVisible.value = true;
                return;
            }
            popupType.value = 'ios';
            isVisible.value = true;
        } else if (platform.value === 'android') {
            popupType.value = 'android';
            isVisible.value = true;
        }
        // localStorage.setItem('app_popup_last_shown', now.toString());
    };




    onMounted(() => {
        detectPlatform();
        checkInstallStatus();
        maybeShowPopup();
    });

    return {
        isVisible,
        platform,
        popupType,
        isInstalled,
        markAsInstalled,
        closePopup,
        isSafari,
        safariWarningVisible
    };
}
